/* unplugin-vue-components disabled */import script from "./parent-message-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./parent-message-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./parent-message-dialog.vue?vue&type=style&index=0&id=3cab9dd8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cab9dd8"]])

export default __exports__